import React, { useEffect, useRef } from 'react';

const AdSense = ({ 
  adSlot = "9006177699", 
  adFormat = "auto", 
  adClient = process.env.REACT_APP_ADSENSE_CLIENT || "ca-pub-2450636270458931",
  style = { display: 'block' },
  fullWidthResponsive = true,
  className = ""
}) => {
  const adRef = useRef(null);
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isAdsEnabled = process.env.REACT_APP_ADSENSE_ENABLED === 'true';

  useEffect(() => {
    // Initialize AdSense in production if ads are enabled
    if (!isDevelopment && isAdsEnabled && typeof window !== 'undefined' && window.adsbygoogle) {
      try {
        window.adsbygoogle.push({});
      } catch (error) {
        console.error('AdSense error:', error);
      }
    }
  }, [isDevelopment, isAdsEnabled]);

  // Show mock ad in development only if ads are enabled
  if (isDevelopment && isAdsEnabled) {
    return (
      <div className={className}>
        <div
          style={{
            ...style,
            border: '2px dashed #ccc',
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            padding: '20px',
            textAlign: 'center',
            color: '#666',
            fontFamily: 'Arial, sans-serif',
            minHeight: '100px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div style={{ fontSize: '14px', marginBottom: '8px' }}>
            📱 AdSense Preview
          </div>
          <div style={{ fontSize: '12px', opacity: 0.7 }}>
            Ad Slot: {adSlot}
          </div>
          <div style={{ fontSize: '12px', opacity: 0.7 }}>
            Format: {adFormat}
          </div>
          <div style={{ fontSize: '10px', marginTop: '8px', opacity: 0.5 }}>
            (Real ads will show in production)
          </div>
        </div>
      </div>
    );
  }

  // Don't render anything if ads are disabled
  if (!isAdsEnabled) {
    return null;
  }

  // Real AdSense for production
  return (
    <div className={className}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={style}
        data-ad-client={adClient}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive.toString()}
      />
    </div>
  );
};

export default AdSense; 